"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belvedere-di-spinello": {
    "a301fc3f": [{
      "hkey": "31139781",
      "slug": "belvedere-di-spinello",
      "name": "Belvedere di Spinello",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "31139781",
      "slug": "belvedere-di-spinello",
      "name": "Belvedere di Spinello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e41cfe29": [{
      "hkey": "31139781",
      "slug": "belvedere-di-spinello",
      "name": "Belvedere di Spinello",
      "primary": true,
      "skipSearch": false
    }],
    "spinello": [{
      "hkey": "31139781",
      "slug": "belvedere-di-spinello",
      "name": "Belvedere di Spinello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;